import { Permissions } from "src/entities/permissions/ui/Permissions";
export const PermissionsPage = () => {
  return <Permissions />;
};
